export enum SsoLinkStatus {
    LINKED = 'LINKED',
    UNLINKED = 'UNLINKED',
    FLAGGED = 'FLAGGED'
}
